import { createContext, useContext } from 'react';
import { WeekDay } from './constants';
export var CalendarContext = createContext({
    setDay: function () { },
    setDayHovered: function () { return true; },
    highlightedDate: null,
    month: 0,
    year: 0,
    getDateEnabled: function () { return true; },
    isFocusWithin: false,
    weekStartsOn: WeekDay.Sunday,
});
export var CalendarContextProvider = CalendarContext.Provider;
export function useCalendarContext() {
    var context = useContext(CalendarContext);
    if (!context) {
        throw new Error('useCalendarContext must be used within a CalendarContextProvider');
    }
    return context;
}
//# sourceMappingURL=CalendarContext.js.map